import Jitsi from "react-jitsi";
import { VFC } from "react";
import { useSelector } from "../../../redux/store";
import { LoadingOverlay } from "../../../components/LoadingOverlay";

export const Meet: VFC<{
  roomId: string;
  onChangeSupport: (value: boolean) => void;
}> = ({ roomId, onChangeSupport }) => {
  const currentUser = useSelector((state) => state.auth.user);
  if (!currentUser?.displayName) {
    return null;
  }

  return (
    <Jitsi
      containerStyle={{
        flex: 1,
        width: "100%",
        height: "100%",
      }}
      frameStyle={{
        display: "block",
        width: "100%",
        flex: 1,
      }}
      config={{
        enableClosePage: false,
        disableDeepLinking: true,
        //@ts-ignore
        prejoinPageEnabled: false,
      }}
      roomName={roomId}
      onAPILoad={(api) => {
        // @ts-ignore
        api.on("browserSupport", ({ supported }) => {
          onChangeSupport(supported);
        });
      }}
      interfaceConfig={{
        MOBILE_APP_PROMO: false,

        TOOLBAR_BUTTONS: ["microphone", "camera", "closedcaptions", "settings"],
        SHOW_JITSI_WATERMARK: false,
        SHOW_CHROME_EXTENSION_BANNER: false,
      }}
      loadingComponent={() => <LoadingOverlay />}
      displayName={currentUser!.displayName}
    />
  );
};
